import React, { useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";

const AddQueryParameterModal = ({
  Show,
  Hide,
  formMetadataList,
  setFormMetadataList,
  setFormCode,
  formCode,
  setFieldCode,
  fieldCode,
  setVersion,
  version,
  setMainVersion,
  mainVersion,
  setFormId,
  formId,
  setFieldId,
  fieldId,
  setCustomField,
  customField,
  setCustomFieldData,
  customFieldData,
  setMainFieldCode,
  mainFieldCode,
  formFields,
  setFieldUnit,
  fieldUnit,
  setFormFields,
  setQuery,
  query,
  setCheckType,
  setEventName,
  setEventId,
  setTimePointLabel,
  setTimePointId,
  checkType,
  eventName,
  eventId,
  timePointLabel,
  timePointId,
  eventRows
}) => {
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewQueryParameter = (checkType, formCode, fieldCode, formId, fieldId, customField, version, eventId, eventName, timePointId, timePointLabel) => {
    setButtonLoader(true);
    const newOption = {
      id: Math.floor(1000000000 + Math.random() * 9000000000),
      checkType: checkType,
      type: "parameter",
      customField: customField,
      value: `${formCode}.${fieldCode}`,
      formId: formId,
      fieldId: fieldId,
      version: version
    };
    if (checkType === "byEvent") {
      newOption.eventId = eventId
      newOption.value = `${eventName}.${formCode}.${fieldCode}`
      newOption.eventName = eventName
      if (timePointId) {
        newOption.value = `${eventName}-(${timePointLabel}).${formCode}.${fieldCode}`
        newOption.timePointId = timePointId
        newOption.timePointLabel = timePointLabel
      }
    }
    let updatedQuery = [...query]
    if (newOption) {
      setQuery([...updatedQuery, newOption])
      setEventName("")
      setEventId("")
      setTimePointLabel("")
      setTimePointId("")
      setFieldCode("")
      setFieldId("")
      setCustomField("")
      setCustomFieldData("")
      setMainFieldCode("")
      setVersion("")
      setFormFields([])
      setFieldUnit("no")
      Hide()
      if (checkType === "byEvent") {
        setFormCode("")
        setFormId("")
        setMainVersion("")
        setFormMetadataList([])
      }
    }
    setButtonLoader(false);
  };

  const selectFormFieldData = (fieldId) => {
    setFieldId(fieldId)
    let fieldData = formFields?.find(item => item.id === Number(fieldId))
    setCustomFieldData(fieldData)
  }

  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            Add Query Parameter
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Type{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setCheckType(e.target.value)}
              className="br3"
              disabled
              style={{ fontSize: 12 }}
            >
              <option selected={checkType === ""} value="">Select Type</option>
              <option selected={checkType === "global"} value="global">Global</option>
              <option selected={checkType === "byEvent"} value="byEvent">By Event</option>
            </Form.Select>
          </Form.Group>
          {checkType === "byEvent" &&
            <>
              <Form.Group className="mb-1">
                <Form.Label className="fw-bold mb-1">
                  Event{" "}
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                </Form.Label>
                <Form.Select
                  onChange={(e) => { setEventId(e.target.value); setTimePointId(e.target[e.target.selectedIndex].id); setEventName(e.target[e.target.selectedIndex].title); setTimePointLabel(e.target[e.target.selectedIndex].dataset.value) }}
                  style={{ fontSize: 12 }}
                  disabled={eventRows?.length === 0}
                  className="br3"
                >
                  <option selected={eventId === ""} value="">Select Event</option>
                  {eventRows?.map((item, index) => (
                    <option key={index} selected={eventId === item?.eventId} value={item?.eventId} title={item?.row?.["EVENTID"]} id={item?.row?.["TIMEPOINTUNIQUEID"] || ""} data-value={item?.row?.["TIMEPOINTID"] || ""}>{item?.row?.["EVENTID"]} {item?.row?.["TIMEPOINTUNIQUEID"] && `(${item?.row?.["TIMEPOINTID"]})`}</option>
                  ))}
                  <option selected={eventId === "specialForm"} value="specialForm" title={"Special Form"} id={""} data-value={""}>Special Form</option>
                </Form.Select>
              </Form.Group>
            </>
          }
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => { setFormCode(e.target.value);; setFormId(e.target[e.target.selectedIndex].id); setMainVersion(e.target[e.target.selectedIndex].title) }}
              className="br3"
              disabled={formMetadataList?.length === 0 || checkType === "global"}
              style={{ fontSize: 12 }}
            >
              <option selected={formCode === ""} value="">Select Form Code</option>
              {formMetadataList?.map((item, index) => (
                <option key={index} selected={formCode === item?.formCode} value={item?.formCode} id={item?.formId} title={item?.version}>{item?.formName}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Version{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setVersion(e.target.value)}
              className="br3"
              disabled={!mainVersion}
              style={{ fontSize: 12 }}
            >
              <option selected={version === ""} value="">Select Version</option>
              {Array.from({ length: mainVersion }, (_, i) => i + 1)?.reverse()?.map((versionNumber, index) => (
                <option key={index} selected={Number(version) === versionNumber} value={versionNumber}>Version {versionNumber}</option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Field{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => { setMainFieldCode(e.target.value); setFieldCode(e.target.value); selectFormFieldData(e.target[e.target.selectedIndex].title); setCustomField(e.target[e.target.selectedIndex].id); setFieldUnit(e.target[e.target.selectedIndex].dataset.value) }}
              className="br3"
              disabled={formFields?.length === 0}
              style={{ fontSize: 12 }}
            >
              <option selected={mainFieldCode === ""} value="">Select Field Code</option>
              {formFields?.map((item, index) => (
                <option key={index} selected={mainFieldCode === item?.fieldName} value={item?.fieldName} title={item?.id} id={item?.customField} data-value={item?.fieldUnit}>{item?.fieldLabel}</option>
              ))}
            </Form.Select>
          </Form.Group>
          {(customField === "yes" || fieldUnit === "yes") &&
            <Form.Group className="mb-1">
              <Form.Label className="fw-bold mb-1">
                Sub-Fields{" "}
                <abbr title="required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Select
                onChange={(e) => setFieldCode(e.target.value)}
                className="br3"
                disabled={formFields?.length === 0}
                style={{ fontSize: 12 }}
              >
                <option selected={fieldCode === ""} value="">Select Sub-Field Code</option>
                <option selected={fieldCode === customFieldData?.fieldName} value={customFieldData?.fieldName}>{customFieldData?.fieldLabel}</option>
                {fieldUnit === "yes" &&
                  <option selected={fieldCode === customFieldData?.fieldUnitName} value={customFieldData?.fieldUnitName} id={JSON.stringify(customFieldData?.unitOptions)}>{customFieldData?.fieldUnitLabel}</option>
                }
                <option selected={fieldCode === customFieldData?.referenceRangeLowerLimitName} value={customFieldData?.referenceRangeLowerLimitName}>{customFieldData?.referenceRangeLowerLimitLabel}</option>
                <option selected={fieldCode === customFieldData?.referenceRangeUpperLimitName} value={customFieldData?.referenceRangeUpperLimitName}>{customFieldData?.referenceRangeUpperLimitLabel}</option>
                <option selected={fieldCode === customFieldData?.referenceRangeIndicatorName} value={customFieldData?.referenceRangeIndicatorName}>{customFieldData?.referenceRangeIndicatorLabel}</option>
                <option selected={fieldCode === customFieldData?.clinicalSignificanceName} value={customFieldData?.clinicalSignificanceName}>{customFieldData?.clinicalSignificanceLabel}</option>
                <option selected={fieldCode === customFieldData?.customRemarkName} value={customFieldData?.customRemarkName}>{customFieldData?.customRemarkLabel}</option>
              </Form.Select>
            </Form.Group>
          }
        </Modal.Body>
        <Modal.Footer className="p-1 px-3 bg-light">
          <button
            className="updateProfile"
            disabled={
              checkType === "byEvent" ?
                (!checkType || !formCode || !fieldCode || !formId || !fieldId || !customField || !version || !eventId || !eventName)
                :
                (!checkType || !formCode || !fieldCode || !formId || !fieldId || !customField || !version)
            }
            onClick={() => addNewQueryParameter(checkType, formCode, fieldCode, formId, fieldId, customField, version, eventId, eventName, timePointId, timePointLabel)}
          >
            {buttonLoader ? (
              <div className="hstackk gap-2">
                <Spinner size="sm" /> Adding...
              </div>
            ) : (
              "Add New"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddQueryParameterModal;
